import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faEraser,
  faPuzzlePiece,
  faTextHeight,
  faQrcode,
  faImage,
  faListUl,
  faMagic,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";

const icon = (type) => {
  switch (parseInt(type)) {
    case 1:
      return faCamera;
    case 2:
      return faVideo;
    case 5:
      return faPuzzlePiece;
    case 6:
      return faListUl;
    case 3:
      return faImage;
    case 0:
      return faTextHeight;
    case 4:
      return faQrcode;
    case 7:
    case 8:
      return faMagic;
    case 9:
    case 10:
      return faEraser;
    default:
      return null;
  }
};

const ChallengeTypeIcon = ({ task_type }) => (
  <FontAwesomeIcon icon={icon(task_type)} />
);

export default ChallengeTypeIcon;
